import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { Carousel } from "bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";

import image from "../assets/Logo.jpg";
import right from "../assets/resized_1.jpeg";
import left from "../assets/resized_2.jpeg";
import Microscope1 from "../assets/resized_3.jpeg";
import Microscope2 from "../assets/resized_4.jpeg";
import compressor from "../assets/resized_5.jpeg";

function Home() {
    useEffect(() => {
        const carouselElement = document.querySelector("#carouselExampleCaptions");
        if (carouselElement) {
            new Carousel(carouselElement, {
                interval: 3000,
                pause: "hover",
                wrap: true,
            });
        }
    }, []);

    return (
        <>
            {/* Contact Info - Email (Left) & Phone (Right) */}
            <div className="d-flex flex-wrap justify-content-between align-items-center p-2 px-3 bg-light">
                <div className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faEnvelope} className="me-2 text-orange" />
                    <span className="fw-bold">ultramobiles07@gmail.com</span>
                </div>
                <div className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faPhone} className="me-2 text-orange" />
                    <span className="fw-bold">9994141075</span>
                </div>
            </div>

            {/* Navbar */}
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container">
                    <Link className="navbar-brand d-flex align-items-center" to="/">
                        <img src={image} className="d-block img-fluid" style={{ maxWidth: "70px", height: "auto" }} alt="Ultramobiles" />
                        <span className="ms-2 brand-title">Ultra Mobiles Training Institute</span>
                    </Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                        <ul className="navbar-nav">
                            <li className="nav-item"><Link className="nav-link" to="/">Home</Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/course">Course</Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/about">About</Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                </div>
            </nav>

            {/* Carousel */}
            <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-indicators">
                    {[...Array(5)].map((_, index) => (
                        <button
                            key={index}
                            type="button"
                            data-bs-target="#carouselExampleCaptions"
                            data-bs-slide-to={index}
                            className={index === 0 ? "active" : ""}
                        ></button>
                    ))}
                </div>
                <div className="carousel-inner">
                    {[right, left, Microscope1, Microscope2, compressor].map((imgSrc, index) => (
                        <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                            <img src={imgSrc} className="d-block w-100 carousel-img img-fluid" alt={`Slide ${index + 1}`} />
                        </div>
                    ))}
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>

            {/* Content Section */}
            <div className="container text-center my-5">
                <h1 className="text-orange fw-bold">Why Should You Join Mobile Service Academy?</h1>
                <p className="lead px-md-5">
                    In today’s fast-paced digital world, mobile phones have become an essential part of life, creating a huge demand for skilled mobile service technicians.
                    At Mobile Service Academy, we provide comprehensive, hands-on training to help you build a successful career in mobile repairing and servicing.
                </p>
            </div>

            {/* Benefits Section */}
            <div className="container">
                <h3 className="text-orange fw-bold">Here's why you should join us:</h3>
                <ul className="list-unstyled px-md-5">
                    <li className="mt-3"><strong>✅ Expert-Led Training</strong><br />Learn from experienced professionals with in-depth industry knowledge.</li>
                    <li className="mt-3"><strong>✅ Practical Hands-On Experience</strong><br />Get real-world training on repairing smartphones, tablets, and other devices.</li>
                    <li className="mt-3"><strong>✅ Latest Tools & Technology</strong><br />Work with advanced diagnostic tools and modern repair techniques.</li>
                    <li className="mt-3"><strong>✅ Certification & Job Assistance</strong><br />Gain a recognized certification and access job placement support.</li>
                    <li className="mt-3"><strong>✅ Affordable Fees & Flexible Learning</strong><br />Quality training at reasonable fees with convenient learning options.</li>
                    <li className="mt-3"><strong>✅ Business & Freelancing Guidance</strong><br />Start your own repair business or become a freelance technician.</li>
                </ul>
            </div>

            {/* Footer */}
            <footer className="bg-orange text-white text-center py-3 mt-5">
                <p className="mb-0">COPYRIGHT © 2025 Ultramobiles Training Institute. All Rights Reserved.</p>
            </footer>

            {/* Styles */}
            <style>
                {`
                    .carousel-img {
                        max-height: 500px;
                        object-fit: cover;
                    }
                    
                    .brand-title {
                        font-weight: bold;
                        font-size: 1.3rem;
                    }

                    @media (max-width: 768px) {
                        .brand-title {
                            font-size: 1.1rem;
                        }
                        .carousel-img {
                            max-height: 350px;
                        }
                    }

                    @media (max-width: 480px) {
                        .brand-title {
                            font-size: 1rem;
                        }
                        .carousel-img {
                            max-height: 250px;
                        }
                    }

                    .text-orange { color: orange; }
                    .bg-orange { background: orange; }
                `}
            </style>
        </>
    );
}

export default Home;
